module.exports = __webpack_public_path__ + "img/fffdesign6.987bd9aa.svg";